import { render, staticRenderFns } from "./SemanaEpidemiologicaForm.vue?vue&type=template&id=7fe33ff3&"
import script from "./SemanaEpidemiologicaForm.vue?vue&type=script&lang=js&"
export * from "./SemanaEpidemiologicaForm.vue?vue&type=script&lang=js&"
import style0 from "./SemanaEpidemiologicaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports